module.exports = __webpack_public_path__ + "static/img/bill_huang_cert.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/bill_huang_cert.jpg
// module id = 1Giy
// module chunks = 0